import { toast } from "react-toastify";

function toSentenceCase(str) {
	if (!str) return '';
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function displayToast(type, message) {
	message = toSentenceCase(message);

	// Capture the stack trace to get the caller's file and line number
	const stackTrace = new Error().stack;
	const callerInfo = stackTrace.split("\n")[2]?.trim(); // Get the second line of the stack trace

	// Append caller info to the message for debugging
	const debugMessage = `${message} (Called from: ${callerInfo})`;

	switch (type) {
		case "ok":
		case "success":
			toast.success(message, {
				position: "bottom-left",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			break;

		case "warn":
			toast.warn(message, {
				position: "bottom-left",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			break;

		case "info":
			toast.info(message, {
				position: "bottom-left",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			break;

		case "error":
			toast.error(message, {
				position: "bottom-left",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			break;

		default:
			toast.error("Unexpected error", {
				position: "bottom-left",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			break;
	}

	console.log(`[DisplayToast] ${type.toUpperCase()}: ${debugMessage}`);

	return { type, message, callerInfo }; // Return metadata for middleware
}

export function initializeDisplayToastMiddleware(trackErrorEvent) {
	// Override the original displayToast function
	const originalDisplayToast = displayToast;

	window.displayToast = (type, message) => {
		// Call the original displayToast function
		const result = originalDisplayToast(type, message);

		// Track errors if the type is "error"
		if (type === "error") {
			trackErrorEvent("Toast Error", message, { callerInfo: result.callerInfo });
		}

		return result;
	};
}

export default displayToast;